import { useStakeExchangeRateQuery } from "@/query/graphql"

// This is used as default for the exchange rate query
export const EXCHANGE_RATE_DECIMALS = 18

export const useStakeExchangeRate = (contractId?: string) => {
  return useStakeExchangeRateQuery(
    {
      contractId: contractId || "",
    },
    { enabled: Boolean(contractId) },
  )
}
